export default {
  install (Vue, options) {
    let local = (name) => {
      return { name: 'en/' + name }
    }

    Vue.prototype.$local = local
  }
}
